import React, { useContext } from 'react';
import styled from '@emotion/styled';
import {
  InitialFeedbackDataType,
  initialFeedbackInitialValues,
  InitialFeedbackSchema,
} from '../../../../models/feedback/feedback.model';
import ModalContainer from '../../ModalContainer';
import { TextInputField } from '../../../Form/FormField';
import { FormComponent } from '../../../Form/FormComponent';
import ValidatingFormSubmitButton from '../../../Button/FormSubmitButton';
import CustomRating from '../../../Form/CustomRating';
import FeedBackGrandChild from '../GrandChildren/InitialFeedBackGrandChild';
import { ModalContext } from '../../../../context/ModalContext';
import useSubmitInitialFeedback from '../../../../hooks/feedbacks/useSubmitInitialFeedback';

const InitialFeedbackModal = () => {
  const { displayModal } = useContext(ModalContext)!;

  const { submitInitialFeedback, loading } = useSubmitInitialFeedback();

  const handleSubmit = async (values: InitialFeedbackDataType) => {
    await submitInitialFeedback(values);
    displayModal(false);
  };

  const confirmClose = () => {
    sessionStorage.setItem('SIFP', 'false');
  };

  return (
    <ModalContainer
      padding="2rem"
      confirm
      granChild={<FeedBackGrandChild />}
      onConfirmClose={confirmClose}
      width="30rem"
    >
      <Header>Help us make Locumspace better for everyone</Header>
      <FormComponent
        initialValues={initialFeedbackInitialValues}
        schema={InitialFeedbackSchema}
        onSubmit={handleSubmit}
        className={'flex'}
      >
        <CustomRating name="rating" />
        <TextInputField
          type="text"
          name="likes"
          label={'What do you like about the Locumspace app ?'}
        />
        <TextInputField
          type="text"
          name="improvements"
          label={'What would you like us to improve on ?'}
        />
        <Div>
          <ValidatingFormSubmitButton
            className="fillParent max-318"
            loading={loading}
          >
            SUBMIT
          </ValidatingFormSubmitButton>
          <p>Page 1 of 1</p>
        </Div>
      </FormComponent>
    </ModalContainer>
  );
};

export default InitialFeedbackModal;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.7rem;
  justify-content: center;
  align-items: center;
`;

const Header = styled.h3`
  font-family: Kanit;
  font-weight: 500;
  font-style: Medium;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -2%;
  text-align: center;
  color: ${({ theme }) => theme.palette.blackBlackMain};

  @media (max-width: 480px) {
    font-size: 18px;
  }
`;
